<template>
	<div :id="number" :class="[heightClass, 'tab-' + this.number]" class="relative tab__background" @click="toggleExpanded()" @click.prevent="active = !active">
		<div class="cancel block lg:hidden absolute top-0 left-0 p-4"><i class="fas fa-times-circle fa-2x text-gray-900 hover:cursor "></i></div>
		<div class="tab__header absolute bottom-0 w-full">
			<a href="#" class="pt-1 px-4 block flex justify-between no-underline tab__link text-white">
				<div>
					<p class="block w-full lg:w-auto m-0 text-xl font-bold uppercase">{{title}}</p>
					<p class="block w-full lg:w-auto m-0 mb-2">by {{author}}</p>
				</div>
			</a>
		</div>     
	</div>
</template>

<script>
	import { mapActions, mapState } from 'vuex';

    export default {

        props: ['number', 'title', 'author'],

        computed: {
        	...mapState('app', [
        		'wrapping_paper',
        		'analytics'
        	]),



        	heightClass() {
        		if (this.wrapping_paper == null) {
        			return 'initial';
        		} else if (this.wrapping_paper == this.number) {
        			return 'expand';
        		} else {
        			return 'collapse';
        		}
        	}
        },

        data() {
			return {
				active: false,
				expanded: false,
			}
		},

		methods: {
			...mapActions('app', [
        		'setActiveWrappingPaper'
        	]),

			toggleExpanded() {
				(this.wrapping_paper != this.number) ? this.setActiveWrappingPaper(this.number) : this.setActiveWrappingPaper(null);
				this.analytics.gaEvent('click', 'navigation', 'home_' + this.title);
			},
		}

    }
</script>